import { useEffect, useState } from "react";
import {
  addUserRoles,
  GetUserRoleCommunities,
  roles,
  userRoles,
} from "../../../API/store/actions/admin/userAction";
import Button from "../../sharedComponents/buttons/button";
import { resolver } from "./../../../API/middlewares/resolveRequests";
import Lang from "../../../userPreferences/staticWords";
import { MemberListItem } from "../../../algorithms/listsAlogrithms";
import { customStyle, styleStart } from "../../../algorithms/styleDirection";
import { objToFormData } from "../../../algorithms";
import DropDownList from "../../sharedComponents/dropdown/dropdown";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UserRoles = ({ userToken, modalVisible, setModalVisible }) => {
  const [rolesData, setRolesData] = useState(null);
  const [newCommunity, setNewCommunity] = useState([]);
  const [roledepend, setRoledepend] = useState("");
  const [roleCommunity, setRoleCommunity] = useState(null);
  useEffect(() => {
    resolver(roles, setRolesData);
  }, []);
  const [disable, setDisable] = useState(false);

  useEffect(() => {
    setRoleCommunity(null);
    if (roledepend) {
      resolver(
        GetUserRoleCommunities,
        setRoleCommunity,
        modalVisible?.helperData?.id,
        roledepend,
        userToken
      );
    }
  }, [roledepend]);
  useEffect(() => {
    setNewCommunity([]);
    if (roleCommunity)
      setNewCommunity([
        ...newCommunity,
        ...roleCommunity?.data?.selectedCommunities.map((item) => item.id),
      ]);
  }, [roleCommunity]);
  const submit = async () => {
    if (disable) {
      return;
    } else {
      setDisable(true);
    }
    let res = await addUserRoles(
      modalVisible?.helperData?.id,
      roledepend,
      newCommunity,
      userToken
    );
    if (res.status <= 206) {
      toast.success("تم التعديل بنجاح", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setDisable(false);
    } else {
      toast.error("حدث خطا اثناء التعديل", {
        position: "top-center",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setDisable(false);
    }
  };
  if (rolesData)
    return (
      <>
        <DropDownList
          dataSource={rolesData?.data?.map((item, index) => {
            return { ...item, name: Lang[item.name] };
          })}
          placeholder={"الصلاحيات"}
          containerStyle={" mx-xl-4 mx-3  "}
          change={(item) => {
            setRoledepend(item.value);
          }}
        />
        {roleCommunity ? (
          <>
            <div className={"d-flex flex-column mx-xl-4 mx-3 my-4 col-12"}>
              <div className={`d-flex px-3 col-11 mb-3 ${styleStart("m", 2)}`}>
                <p className="my-0">{"البرامج البحثية"}</p>
              </div>

              <div
                className={`d-flex flex-column col-11 px-3 py-2 mx-1 mx-lg-3 mx-xl-4 ${customStyle(
                  "TitleCard"
                )}`}
                style={{
                  height: "fit-content",
                  maxHeight: 250,
                }}
              >
                <div className="d-flex flex-column scroll py-3">
                  {!roleCommunity?.data?.allCommunities?.length ||
                  [
                    "79a78075-126d-4f9b-b91c-08d9e572b6af",
                    "b9f90cee-8c06-4879-b91d-08d9e572b6af",
                    "dd700081-76c8-4b93-b921-08d9e572b6af",
                  ].includes(roledepend) ? (
                    <div className="text-center"> لا يوجد برامج بحثية </div>
                  ) : (
                    roleCommunity?.data?.allCommunities?.map((item, index) => {
                      let communityPhoto = `url("/assets/images/icons/access-granted.png")`;
                      return (
                        <MemberListItem
                          key={index}
                          id={item.id}
                          photo={item?.logo ?? communityPhoto}
                          index={index}
                          name={item.name}
                          onChange={(e) => {
                            const checked = e.target.checked;
                            const value = parseInt(e.target.value);
                            if (checked) {
                              setNewCommunity([...newCommunity, value]);
                            } else {
                              setNewCommunity(
                                newCommunity.filter((item) => item != value)
                              );
                            }
                          }}
                          values={newCommunity}
                          length={
                            roleCommunity?.data?.allCommunities?.length - index
                          }
                          checked={true}
                          idChar={"B"}
                        />
                      );
                    })
                  )}
                </div>
                <div style={{ fontSize: 14, color: "red" }}></div>
              </div>
            </div>
            <div className="d-flex justify-content-center  ">
              <Button
                disable={disable}
                content={disable ? Lang.saving : Lang.save}
                buttonStyleType="solid"
                onClick={() => {
                  submit();
                }}
                containerStyle={"m-3 col-3 "}
              />
              <Button
                content={Lang.cancel}
                onClick={() => {
                  setModalVisible({
                    ...modalVisible,
                    addRole: false,
                    helperData: null,
                  });
                  setDisable(false);
                }}
                containerStyle={"m-3 col-3 "}
              />
            </div>{" "}
          </>
        ) : (
          <div className="text-center py-2"> اختر صلاحية </div>
        )}
      </>
    );

  return <>LOADING</>;
};

export default UserRoles;
